import { render, staticRenderFns } from "./CrudLayout.vue?vue&type=template&id=62db8900"
import script from "./CrudLayout.vue?vue&type=script&lang=ts"
export * from "./CrudLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports